import Icon from "@components/ui/icon";
import Popover from "@components/ui/popover";
import { cn } from "@lib/cn";
import type { Dispatch, SetStateAction } from "react";
import { type IMediaFolderUser, MediaFolderPermEnum } from "@/shared/types";

interface IProps {
  isPicking: boolean;
  setIsPicking: Dispatch<SetStateAction<boolean>>;
  user: IMediaFolderUser;
  setUserType: (type: MediaFolderPermEnum) => void;
}

const OPTIONS: { label: string; type: MediaFolderPermEnum }[] = [
  {
    label: "Owner",
    type: MediaFolderPermEnum.Owner,
  },
  {
    label: "Editor",
    type: MediaFolderPermEnum.Editor,
  },
];

export const MediaLibMembersFolderDialogUserType = ({
  isPicking,
  setIsPicking,
  user,
  setUserType,
}: IProps) => {
  return (
    <Popover open={isPicking} onOpenChange={setIsPicking}>
      <Popover.Trigger
        className={cn(
          "tw-flex tw-items-center tw-rounded-md tw-px-2 tw-py-1 tw-text-[11px] tw-text-blue-500 tw-transition-colors hover:tw-bg-blue-100",
          isPicking && "tw-bg-blue-100",
        )}
      >
        {user.type === MediaFolderPermEnum.Editor ? "Editor" : "Owner"}
        <Icon icon="ri-expand-up-down-line" className="tw-ml-2" />
      </Popover.Trigger>
      <Popover.Content
        className="tw-z-[10003] tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-shadow-popover"
        data-sd-is-floating-popover
      >
        <ol className="tw-m-0 tw-grid tw-min-w-28 tw-list-none tw-content-start tw-gap-1 tw-p-2">
          {OPTIONS.map((opt) => (
            <Option
              key={opt.type}
              label={opt.label}
              type={opt.type}
              user={user}
              setIsPicking={setIsPicking}
              setUserType={setUserType}
            />
          ))}
        </ol>
      </Popover.Content>
    </Popover>
  );
};

interface IOptionProps {
  label: string;
  user: IMediaFolderUser;
  type: MediaFolderPermEnum;
  setUserType: IProps["setUserType"];
  setIsPicking: IProps["setIsPicking"];
}

const Option = ({
  label,
  type,
  user,
  setIsPicking,
  setUserType,
}: IOptionProps) => {
  return (
    <li
      onClick={() => {
        setUserType(type);
        setIsPicking(false);
      }}
      className={cn(
        "tw-cursor-pointer tw-rounded tw-px-3 tw-py-2 tw-text-[11px] tw-transition-colors hover:tw-bg-primary-100 hover:tw-text-primary",
        user.type === type && "tw-bg-primary-100 tw-text-primary",
      )}
    >
      {label}
    </li>
  );
};
